import { Theme } from "./symbols";

/** Nortegas-branded theme CSS property values. */
export const NORTEGAS_THEME: Theme = {
  name: "nortegas",
  properties: {
    // Navbar
    "--color-navbar-background": "#0a364a",
    "--color-navbar-background-scrollbar": "#56b7e4",

    // Global
    "--color-netmore-blue": "#005a94",
    "--color-arson-pink": "#a50078",
    "--color-black": "#000000",
    "--color-white": "#ffffff",
    "--color-white-light": " #f8f8ff",
    "--color-white-dark": "#f5f5f5",

    // Shadows
    "--color-black-shadow": "rgba(0, 0, 0, 0.5)",
    "--color-black-shadow-light": "rgba(0, 0, 0, 0.2)",
    "--color-black-shadow-minimal": "rgba(0, 0, 0, 0.05)",
    "--color-white-shadow": "rgba(255, 255, 255, 0.4)",
    "--color-white-shadow-dark": "rgba(255, 255, 255, 0.9)",

    // Misc
    "--color-red": "#d32f2f",
    "--color-red-light": "#ff6666",
    "--color-red-dark": "#990000",
    "--color-red-alarm": "#b71c1c",
    "--color-blue": "#1976d2",
    "--color-blue-light": "#64a9ed",
    "--color-blue-dark": "#0e4377",
    "--color-green": "#43a047",
    "--color-green-light": "#00e600",
    "--color-green-dark": "#2e662e",
    "--color-gray": "#cdcecf",
    "--color-gray-light": "#ddddddff",
    "--color-gray-dark": "#6b6b6bff",
    "--color-orange": "#e69e19",
    "--color-orange-light": "#ffae5c",
    "--color-orange-dark": "#aa5b01ff",
    "--color-brown": "#613002",
    "--color-brown-light": "#b96c23ff",
    "--color-brown-dark": "#1d0e01ff",
    "--color-yellow": "#ffeb3b",
    "--color-yellow-light": "#ffff93",
    "--color-yellow-dark": "#ffae00",
    "--color-pink": "#bc47b2ff",
    "--color-pink-light": "#e78de0ff",
    "--color-purple": "#8f3ab7ff",
    "--color-purple-light": "#c782e7ff",
    "--color-purple-dark": "#610d88ff",
    "--color-turquoise": "#2ac0ca",
    "--color-turquoise-light": "#6fe2dc",
    "--color-turquoise-dark": "rgba(47, 172, 165, 1)",
    "--color-cadetblue": "#5f9ea0",
    "--color-cadetblue-light": "#b5f1f3"
  }
};
